"use client";

import type { ReactNode } from "react";

type Notice = {
  tone: "info" | "success" | "error";
  message: string;
};

type WorkspacePageStateKind = "empty" | "loading" | "blocked" | "action" | "success" | "error";

export function WorkspaceNotice({ notice, children }: { notice: Notice; children?: ReactNode }) {
  return (
    <section className={`notice ${notice.tone}`} aria-live="polite">
      <span>{notice.message}</span>
      {children}
    </section>
  );
}

export function WorkspacePageState({
  kind,
  title,
  description,
  children,
}: {
  kind: WorkspacePageStateKind;
  title: string;
  description?: string;
  children?: ReactNode;
}) {
  return (
    <div className={`workspace-page-state ${kind}`} role={kind === "error" ? "alert" : "status"}>
      <strong>{title}</strong>
      {description ? <span>{description}</span> : null}
      {children}
    </div>
  );
}

export function WorkspaceSection({
  ariaLabel,
  className,
  state,
  children,
}: {
  ariaLabel: string;
  className?: string;
  state?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className={className} aria-label={ariaLabel}>
      {state}
      {children}
    </section>
  );
}

export function WorkspacePlaceholder({
  title,
  badge,
  description,
  checklist,
}: {
  title: string;
  badge: string;
  description: string;
  checklist: string[];
}) {
  return (
    <section className="workspace-placeholder surface">
      <div className="surface-heading">
        <h2>{title}</h2>
        <span>{badge}</span>
      </div>
      <p className="empty-state">{description}</p>
      <div className="placeholder-checklist">
        {checklist.map((item) => (
          <span key={item}>{item}</span>
        ))}
      </div>
    </section>
  );
}
